import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { Content, CopyFunction } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const {
  CONTENT,
  CHECK_SYMPTOMS,
  BOOK_APPOINTMENT,
  PRESCRIPTION,
  CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
} = USA
const { WELCOME, REGISTRATION, FAMILY, SUMMARY, ELIGIBILITY } = CONTENT

const partnerName = 'Fidelis NY Medicaid'
const planName = 'Fidelis Care'

const content: Content = {
  'en-US': {
    steps: [
      {
        ...WELCOME.enUS,
        copy: (WELCOME.enUS.copy as CopyFunction)(planName),
        productFeatures: [
          CHECK_SYMPTOMS.enUS,
          BOOK_APPOINTMENT.enUS,
          {
            ...PRESCRIPTION.enUS,
            title:
              'Get prescriptions sent to a local pharmacy of your choice (restrictions may apply)',
          },
        ],
      },
      {
        ...REGISTRATION.enUS,
        copy: ['Enter your details to register'],
      },
      {
        ...FAMILY.enUS,
        copy: [
          'Add your family members so they can have access to our services',
        ],
      },
      ELIGIBILITY.enUS,
      SUMMARY.enUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
}

const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
    id: 'fidelis-medicaid',
    productConfigAppName: 'fidelis-medicaid',
    name: partnerName,
    codes: {
      membership: 'fidelismedicaidautoapp',
    },
    partnerUrlSlug: 'fidelisny',
  },
  content,
}

const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
}

export default [baseConfig, baseConfigWithDnaV2Design]
